// Re-exported from terrain.ts, which owns them (see terrain.ts for why).
export { MAP_GRID_SIZE, MAP_CENTER, START_RADIUS, MAX_RADIUS, } from "./terrain.js";
export const COMPANY_TYPES = [
    "service",
    "mechanic",
    "forestry",
    "agriculture",
    "metalworks",
];
// One-time permanent resource grant per company created (total = 4 per company)
export const RESOURCE_GRANTS = {
    forestry: { wood: 3, steel: 0, manpower: 1 },
    metalworks: { wood: 0, steel: 3, manpower: 1 },
    mechanic: { wood: 0, steel: 2, manpower: 2 },
    agriculture: { wood: 2, steel: 0, manpower: 2 },
    service: { wood: 0, steel: 0, manpower: 4 },
};
export const SPECIAL_BUILDINGS = {
    bastei: {
        type: "bastei",
        name: "Bastei",
        description: "Ein imposantes Wahrzeichen für eure Stadt.",
        cost: { wood: 8, steel: 4, manpower: 6 },
        unique: true,
        placement: "land",
        connectsToStreet: true,
    },
    police: {
        type: "police",
        name: "Polizeiwache",
        description: "Für Recht und Ordnung in eurer Stadt.",
        cost: { wood: 2, steel: 6, manpower: 4 },
        unique: true,
        placement: "land",
        connectsToStreet: true,
    },
    park: {
        type: "park",
        name: "Stadtpark",
        description: "Ein grüner Rückzugsort für alle Bürger.",
        cost: { wood: 3, steel: 0, manpower: 2 },
        unique: false,
        placement: "land",
        connectsToStreet: false,
    },
    bridge: {
        type: "bridge",
        name: "Brücke",
        description: "Verbindet die Ufer über das Wasser hinweg.",
        cost: { wood: 4, steel: 2, manpower: 1 },
        unique: false,
        placement: "water",
        connectsToStreet: true,
    },
};
// German placement-error copy shared between build.ts's server-side checks and GameScene.ts's
// client-side pre-check toast (the same 4 rules, checked in both places) — one wording, not two.
export const PLACEMENT_ERRORS = {
    occupied: "Dieses Feld ist bereits belegt.",
    outOfBounds: "Dieses Feld liegt außerhalb des Stadtgebiets.",
    wrongTerrainLand: "Hier kann nicht gebaut werden (Wasser/Wald).",
    wrongTerrainWater: "Eine Brücke muss auf Wasser gebaut werden.",
};
export function isHttpUrl(value) {
    try {
        const url = new URL(value);
        return url.protocol === "http:" || url.protocol === "https:";
    }
    catch {
        return false;
    }
}
// Terrain layer — checked-in template, shared by server (placement rules) and client (rendering).
export { parseTerrain, validateTerrain, edgeBitmask } from "./terrain.js";
import { parseTerrain as _parseTerrain } from "./terrain.js";
import { TERRAIN_ROWS } from "./terrain-data.js";
export const TERRAIN = _parseTerrain(TERRAIN_ROWS);
